import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { Route } from 'react-router-dom'
import { observer, inject, Provider } from 'mobx-react'
import { extendObservable } from 'mobx'
import PropTypes from 'prop-types'
import pick from 'lodash/pick'

import ExpertHeader from './Components/ExpertHeader'
import Details from './Details'
import ExpertHistory from './ExpertHistory'
import HFCompliance from './HFCompliance'
import HFCompliances from './HFCompliances'
import PaymentDetails from './PaymentDetails'

import ACL from '@components/ACL'
import Logs from '@components/Logs'
import Scroll from '@components/Scroll'
import Spinner from '@components/spinner'
import Tabs from '@components/Tabs/Tabs'

import HistoryStore from './stores/history.store'
import CommentStore from '@components/Comments/Comment.store'

class ExpertPage extends Component {
  static propTypes = {
    staticData: PropTypes.object,
    growlStore: PropTypes.object,
    expertStore: PropTypes.object,
    expertSearchStore: PropTypes.object,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string
      }).isRequired,
      url: PropTypes.string
    }).isRequired,
    location: PropTypes.object
  }

  constructor(props) {
    super(props)
    const commentStore = new CommentStore()
    extendObservable(this, {
      commentStore,
      historyStore: new HistoryStore(props.expertStore, props.expertSearchStore)
    })
    props.expertStore.addHistory(this.props.history)
    this.loadExpert()
  }

  loadExpert() {
    const { match, expertStore, expertSearchStore } = this.props

    const expertId = Number(match.params.id) || match.params.id

    if (expertStore.id === expertId) return
    expertSearchStore.selectExpert(expertId)
    expertStore.loadData(expertId)
    extendObservable(this, {
      historyStore: new HistoryStore(expertStore, expertSearchStore)
    })

    expertStore.addHistory(this.props.history)
  }

  componentDidUpdate() {
    this.loadExpert()
  }

  render() {
    const { expertStore, match, location, expertSearchStore } = this.props
    const { commentStore } = this
    const { expertCopy, loading } = expertStore

    if (loading) return <Spinner />

    let highlightDetails = false
    let highlightHistory = false

    if (
      expertCopy &&
      expertCopy.highlight &&
      expertSearchStore.query.includeScreeningInformation
    ) {
      if (
        Object.keys(expertCopy.highlight).find(key => key.includes('screening'))
      ) {
        highlightHistory = true
      }

      const keys = [
        'experiences.company',
        'experiences.position',
        'experiences.description',
        'industryExpertise',
        'expertExperience'
      ]
      if (Object.keys(expertCopy.highlight).find(key => keys.includes(key))) {
        highlightDetails = true
      }
    }

    const matchId = match.params.id
    const matchUrl = location.pathname
    const tabs = [
      {
        tab: 'details',
        highlight: highlightDetails
      },
      {
        tab: 'history',
        highlight: highlightHistory
      },
      {
        tab: 'payment-details',
        roles: ['AdvancedExpertManagement', 'Accounting', 'BasicExpert']
      },
      {
        tab: 'hf-compliances'
      },
      {
        tab: 'logs'
      }
    ]

    return (
      <Provider
        {...pick(this, ['expertStore', 'historyStore', 'commentStore'])}>
        <div className="expert-page-wrapper">
          <Scroll>
            <div className="expert-wrapper">
              <ExpertHeader
                expert={expertStore.expert}
                commentStore={commentStore}
              />

              <div className="expert-tabs">
                <Tabs
                  matchId={matchId}
                  matchUrl={matchUrl}
                  match={match}
                  tabs={tabs}
                />
              </div>

              <div className="views-wrapper">
                <Route exact path={match.url} component={Details} />
                <Route
                  exact
                  path={match.url + '/history'}
                  component={ExpertHistory}
                  matchId={matchId}
                />
                <ACL
                  roles={[
                    'AdvancedExpertManagement',
                    'Accounting',
                    'BasicExpert'
                  ]}>
                  <Route
                    exact
                    path={match.url + '/payment-details'}
                    component={PaymentDetails}
                  />
                </ACL>
                <Route
                  exact
                  path={match.url + '/hf-compliances'}
                  component={HFCompliances}
                />
                <Route
                  exact
                  path={match.url + '/hf-compliance/:hfComplianceId'}
                  component={HFCompliance}
                />
                <Route
                  path={match.url + '/logs'}
                  render={props => (
                    <Logs
                      {...props}
                      type="expert"
                      itemId={expertStore.expert.id}
                    />
                  )}
                />
              </div>
            </div>
          </Scroll>
        </div>
      </Provider>
    )
  }
}

export default withRouter(
  inject(
    'staticData',
    'growlStore',
    'expertStore',
    'expertSearchStore'
  )(observer(ExpertPage))
)
